export default [
  {
    path: '/inventory/:key?',
    name: 'inventoryPage',
    component: () => import(/*webpackChunkName:'inventory'*/ '@/views/inventory/index.vue'),
    meta: {},
  },
];
